import { useInjection } from 'inversify-react';

import { Button } from '@desygner/ui-common-components';
import { useProjects } from '@desygner/ui-features-projects';

import { arrowLeftShortcut } from '../../../../../core/viewer/shortcuts/arrow-left';
import { arrowRightShortcut } from '../../../../../core/viewer/shortcuts/arrow-right';
import { TYPES } from '../../../../../inversify.types';
import { IViewerStoreInjector } from '../../../../../store';
import { useResponsive } from '../../../../hooks/useResponsive';
import { StyledButtonSize } from '../BottomNav.styles';
import {
  StyledMobileNavigationWrapper,
  StyledTypography,
  StyledWrapper,
} from './PageNavigationController.styles';

export const PageNavigationController = () => {
  const useViewerStore = useInjection<IViewerStoreInjector>(TYPES.Store.Viewer);

  const { isTabletOrMobile } = useResponsive();
  const { project } = useProjects();
  const selectedPageNumber = useViewerStore((state) => state.selectedPageNumber);

  const totalPages = project?.total_pages ?? 0;

  function handlePageChange(type: 'prev' | 'next') {
    return (_event: React.MouseEvent<HTMLButtonElement>) => {
      if (type === 'next') {
        arrowRightShortcut.callBackFunction();
        return;
      }

      arrowLeftShortcut.callBackFunction();
    };
  }

  if (isTabletOrMobile) {
    return (
      <StyledMobileNavigationWrapper>
        {selectedPageNumber} / {totalPages}
      </StyledMobileNavigationWrapper>
    );
  }

  return (
    <StyledButtonSize>
      <StyledWrapper>
        <Button
          icon={{
            name: 'chevron---left',
          }}
          size="Small"
          variant="ghost"
          onClick={handlePageChange('prev')}
          action="navigation-page"
          dataset={{
            direction: 'previous',
          }}
        />

        <StyledTypography data-active-page={selectedPageNumber}>
          {selectedPageNumber} / {totalPages}
        </StyledTypography>

        <Button
          icon={{
            name: 'chevron---right',
          }}
          size="Small"
          variant="ghost"
          action="navigation-page"
          dataset={{
            direction: 'next',
          }}
          onClick={handlePageChange('next')}
        />
      </StyledWrapper>
    </StyledButtonSize>
  );
};
